import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CashBack as ValueCashback } from 'Catalog/Availability/PriceLabel'

const CashBack = ({ price, onlyCash, decimalPlaces, pointsName, className, showDefaultMultiplier }) => {
  let currency = {
    decimalPlaces,
    name: pointsName
  }

  const hasCashBack = process.env.REACT_APP_HAS_CASHBACK
  const ruleCashBack = process.env.REACT_APP_RULE_CASHBACK || '1'

  return (
    <Fragment>
      {hasCashBack && onlyCash && (
        <div className={`${className || 'box-cashback row py-1 px-2 border-top border-color-ui-3'}`}>
          <ValueCashback
            hideIcon
            showInstallments
            showDefaultMultiplier={showDefaultMultiplier}
            price={price}
            currency={currency}
            hasCashBack={hasCashBack}
            ruleCashBack={ruleCashBack}
          />
          <div className='col-12'>
            <p className='txt-body-sm txt-font-body'>Estes {pointsName || 'pontos'} serão creditados em até 40 dias</p>
          </div>
        </div>
      )}
    </Fragment>
  )
}

CashBack.propTypes = {
  price: PropTypes.number,
  onlyCash: PropTypes.bool,
  pointsName: PropTypes.string,
  decimalPlaces: PropTypes.number,
  className: PropTypes.string,
  showDefaultMultiplier: PropTypes.bool
}

const mapStateToProps = ({ catalog: { currencyConfiguration }, onlyCash }) => ({
  pointsName: currencyConfiguration.pointsName,
  decimalPlaces: currencyConfiguration.decimalPlaces,
  onlyCash
})

export default connect(
  mapStateToProps,
  null
)(CashBack)



// WEBPACK FOOTER //
// ./src/features/CashBack/CashBack.js